import {
  ChipDirective,
  ChipListComponent,
  ChipsDirective,
  SwitchComponent,
} from '@syncfusion/ej2-react-buttons';
import {
  DateRangePickerComponent,
  TimePickerComponent,
} from '@syncfusion/ej2-react-calendars';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import {
  ButtonPropsModel,
  DialogComponent,
} from '@syncfusion/ej2-react-popups';
import React, { useContext, useEffect, useState } from 'react';
import { GetRosters } from '../services/Settings/Roster';
import {
  GetRostersTemplate,
  GetRostersTemplateDetail,
} from '../services/Settings/RostersTemplate';
import { all_information, loadingShow } from '../App';
import Message from './Message/Message';
import { ThemeContext } from '../context/theme.context';
import moment from 'moment';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {
  AddCapacityRequest,
  CreateNoteCapacity,
  DeleteCapacityRequest,
} from './CreateRequest';
import TPlannerNoteContent from './TradePlannerHelper';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
import {useSelector} from "react-redux";
interface IProps {
  hideDialog: boolean;
  setHideDialogCapacity: (cond: boolean) => void;
  assignments: Array<any>;
  isNoteMode?: boolean;
  rangeDefined?: {
    endTime: Date;
    startTime: Date;
  };
}
var selectedName: string = '';
var deleteCapacitySwichValue1: boolean = true;
var deleteExceptionSwichValue1: boolean = true;
var deleteCapacitySwichValue2: boolean = true;
var deleteExceptionSwichValue2: boolean = true;
var selectedChip: Array<any> = [0, 1];
var selectedChip2: Array<any> = [0, 1];
var weekStartNumber: number = -1;
var dropDownExceptionSelection = -1;
var exeptionStarthour: Date = new Date();
var exeptionDuration: Date = new Date();
var dateRangePickerExceptionValue: any = '';
var dateRangePickerTemplateValue: any = '';
var templateName: Array<any> = [];
var actionData: Array<any> = [];
var list: Array<any> = [];
var unionUserData: Array<any> = [];
var fieldsForDropdown: object = { text: 'rosterCode' };
var theDialog: DialogComponent = new DialogComponent({});
var noteDesc: any = new TextBoxComponent({});
var theTypeDD: DropDownListComponent;
function GenerateCapacity({
  isNoteMode,
  hideDialog,
  setHideDialogCapacity,
  assignments = [],
  rangeDefined,
}: IProps) {
  const [isRosterTemplateSelected, setIsRosterTemplateSelected] =
    useState(false);
  const server_gmt = useSelector((state: any) => state.search.server_gmt);
  const [isException, setIsException] = useState(false);
  const [exceptionData, setExceptionData] = useState<Array<any>>([]);
  const [isDangerShow2, setIsDangerShow2] = useState(false);
  const [isDangerShow, setIsDangerShow] = useState(false);
  const [isSameDay, setIsSameDay] = useState(false);
  const [TemplateData, setTemplateData] = useState<Array<any>>([]);
  const [endDate, setEndDate] = useState<Date>();
  const [showEndDate, setShowEndDate] = useState(false);
  const [weekDay, setWeekDay] = useState<Array<any>>([
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ]);
  const [roosterData, setRoosterData] = useState<Array<any>>([]);
  const [dropDownTemlateSelection, setDropDownTemlateSelection] = useState('');
  const [weeksValue, setWeeksValue] = useState(2);
  const [selectedNoteColor, setSelectedNoteColor] = useState<string>('');
  const [isCapacitySwitchChecked, setIsCapacitySwitchChecked] =
    useState<boolean>(true);
  const context = useContext(ThemeContext);
  const buttons: ButtonPropsModel[] = [
    {
      click: () => {
        createCapacityforAssignment();
      },
      buttonModel: {
        content: 'Save',
        isPrimary: true,
      },
    },
    {
      click: () => {
        list = [];
        setIsRosterTemplateSelected(false);
        setHideDialogCapacity(false);
      },
      buttonModel: {
        content: 'Cancel',
      },
    },
  ];
  const swichTemplateToExpection = (args: any) => {
    var isShiftTemplateSelectedDedect = isRosterTemplateSelected;
    if (isRosterTemplateSelected) {
      isShiftTemplateSelectedDedect = isException ? true : false;
    }
    setIsException(!isException);
    setIsRosterTemplateSelected(isShiftTemplateSelectedDedect);
    if (args.checked) {
      theDialog.content = exceptionForm;
      theDialog.refresh();
    } else {
      theDialog.content = shiftContent;
      theDialog.refresh();
    }
  };
  const isChipClicked1 = (e: any) => {
    if (e.index === 0) {
      deleteExceptionSwichValue1 = e.selected;
      if (!e.selected) {
        selectedChip.shift();
      } else {
        selectedChip.unshift(0);
      }
    } else if (e.index === 1) {
      deleteCapacitySwichValue1 = e.selected;
      if (!e.selected) {
        selectedChip.pop();
      } else {
        selectedChip.push(1);
      }
    }
  };
  const isChipClicked2 = (e: any) => {
    if (e.index === 0) {
      deleteExceptionSwichValue2 = e.selected;
      if (!e.selected) {
        selectedChip2.shift();
      } else {
        selectedChip2.unshift(0);
      }
    } else if (e.index === 1) {
      deleteCapacitySwichValue2 = e.selected;
      if (!e.selected) {
        selectedChip2.pop();
      } else {
        selectedChip2.push(1);
      }
    }
  };
  const dateRangePicker = (props: any) => {
    let startCheck: string;
    let endCheck: string;
    dateRangePickerExceptionValue = props.value;
    if (props.value) {
      let start = props.value[0];
      let end = props.value[1];
      var startDate = JSON.stringify(start).replaceAll('"', '');
      var endDate = JSON.stringify(end).replaceAll('"', '');
      startCheck = startDate;
      endCheck = endDate;
      if (startCheck == endCheck) {
        setIsSameDay(dropDownExceptionSelection !== -1 ? true : false);
        setIsDangerShow2(deleteExceptionSwichValue2);
      } else {
        setIsSameDay(false);
        setIsDangerShow2(deleteExceptionSwichValue2);
      }
    }
  };
  const itemTemplateShiftColor = (data: any): JSX.Element => {
    return (
      <span>
        <span
          id='exceptiontColor'
          style={{ backgroundColor: data.rostercolor }}
        ></span>
        <span>{data.rosterCode + ' - ' + data.description}</span>
      </span>
    );
  };
  const getShiftData = async () => {
    await GetRosters().then((res) => {
      let execptioName: any = [];
      execptioName = res.data.filter((res: any) => {
        return res.rosterType === 'Exception';
      });
      execptioName.unshift({ rosterCode: '', rosterId: -1, description: '' });
      setExceptionData(execptioName);

      const customData = res.data.filter((e: any) => {
        return e.isrostered;
      });
      customData.unshift({ rosterCode: '', rostercolor: '' });
      setRoosterData(customData);
    });

    GetRostersTemplate().then((result) => {
      templateName = [];
      result.data.map((res: any) => {
        templateName.push({
          description: res.rt_template_name + ' - ' + res.rt_description,
          id: res.rt_id,
        });
      });
      templateName.unshift({ description: '', id: -1 });
      setTemplateData(templateName);
    });
  };
  const onChangeDuration = (e: any) => {
    var startTime = $('#datetimepickerStart').val() as any;
    var startHour = parseInt(startTime?.split(':')[0]);
    var startMinutes = parseInt(startTime?.split(':')[1]);
    var date = new Date(e.value);
    var newDate = date.setTime(
      date.getTime() + (startHour * 60 * 60 + startMinutes * 60) * 1000
    );
    var result = new Date(newDate);
    exeptionDuration = e.value;
    setEndDate(result);
    setShowEndDate(true);
  };
  const dateRangePickerTemplate = (props: any) => {
    dateRangePickerTemplateValue = props.value;
    setIsDangerShow(deleteCapacitySwichValue1);
  };
  const getTheAssignmentsTemplate = (
    data: any,
    assignment: any,
    tr: any,
    weekCount: number
  ) => {
    let theTemp: Array<any> = [];
    data.shiftTemplateDetail.map((el: any) => {
      var color = roosterData.filter((e: any, index: number) => {
        return e.rosterCode === el.shift;
      });
      theTemp.push({
        day_sequence: el.day_sequence?.toString(),
        shift: el.shift === '' ? null : el.shift,
        element_alias: color.length > 0 ? color[0].elementAliasValue : '',
        trade_id: tr?.trade_id ? tr.trade_id : 0,
        trade_code: tr?.trade_code,
        team_id: assignment?.team_id,
        team_code: assignment?.team_code,
        assignment: assignment.assignment_id,
        shift_color: color.length > 0 ? color[0].rostercolor : '',
        templateId: Number(data.rt_id),
        start_time: color.length > 0 ? color[0].startTime : '',
        end_time: color.length > 0 ? color[0].endTime : '',
        break_time: color.length > 0 ? color[0].breakTime : '',
        capacity: color.length > 0 ? color[0].capacity : '',
        start_date: '',
        end_date: '',
      });
    });
    if (data.shiftTemplateDetail.length === 0) {
      for (let i = 1; i <= weekCount; i++) {
        for (let j = 1; j <= 7; j++) {
          theTemp.push({
            day_sequence: i + '' + 'j',
            shift: '',
            element_alias: '',
            trade_id: tr?.trade_id ? tr.trade_id : 0,
            trade_code: tr?.trade_code,
            team_id: assignment?.team_id,
            team_code: assignment?.team_code,
            assignment: assignment.assignment_id,
            shift_color: '',
            templateId: Number(data.rt_id),
            start_time: '',
            end_time: '',
            break_time: '',
            capacity: '',
            start_date: '',
            end_date: '',
          });
        }
      }
    }
    return theTemp;
  };
  const selectTemplateOnChange = async (e: any) => {
    if (e.value !== -1) {
      loadingShow(true, 'Preparing');
      unionUserData = [];
      actionData = [];
      GetRostersTemplateDetail(e.value)
        .then((response) => {
          loadingShow(false, 'Preparing');
          const weekCount = response.data[0].rt_week;
          const temp = [...weekDay];
          weekStartNumber = response.data[0].rt_weekstart;
          const parseTemp = temp.splice(Number(weekStartNumber));
          parseTemp.push(...temp);
          var theData: Array<any>;

          assignments.map((assignment) => {
            theData = [];
            if (assignment.trades) {
              if (assignment.trades.length > 0) {
                assignment.trades.map((tr: any) => {
                  theData.push(
                    ...getTheAssignmentsTemplate(
                      response.data[0],
                      assignment,
                      tr,
                      weekCount
                    )
                  );
                });
              }

              unionUserData.push(theData);
            } else {
              theData = getTheAssignmentsTemplate(
                response.data[0],
                assignment,
                undefined,
                weekCount
              );
              unionUserData.push(theData);
            }
          });
          setDropDownTemlateSelection(e.value);
          setWeeksValue(weekCount);
          setIsRosterTemplateSelected(true);
          setIsDangerShow(false);
          setWeekDay(parseTemp);
        })
        .catch((e) => {
          loadingShow(false, 'Preparing');
          Message.error('Error occured while getting detail to source');
          //(e);
        });
    } else {
      setDropDownTemlateSelection(e.value);
      setIsRosterTemplateSelected(false);
    }
  };
  const changeDrop = (uID: number, e: any) => {
    const incomming = e.target.id;
    var currentData = e.value === '' ? null : e.value;
    const index = unionUserData[uID]?.findIndex(
      (e: any) => e.day_sequence === incomming
    );
    var comp;
    if (currentData != null) {
      if (currentData === unionUserData[uID][index]?.shift) {
        comp = e.target as DropDownListComponent;
        comp.clear();
        Message.error('Two different shifts must be selected on the same day');
        return;
      }
    }
    var theShift = roosterData.filter((e: any, index: number) => {
      return e.rosterCode === currentData;
    });
    unionUserData[uID][index].shift = currentData;
    unionUserData[uID][index].shift_color =
      theShift.length > 0 ? theShift[0]?.rostercolor : '';
    unionUserData[uID][index].start_time =
      theShift.length > 0 ? theShift[0]?.startTime : '';
    unionUserData[uID][index].end_time =
      theShift.length > 0 ? theShift[0]?.endTime : '';
    unionUserData[uID][index].element_alias =
      theShift.length > 0 ? theShift[0]?.elementAliasValue : '';
    unionUserData[uID][index].break_time =
      theShift.length > 0 ? theShift[0]?.breakTime : '';
    unionUserData[uID][index].capacity =
      theShift.length > 0 ? theShift[0]?.capacity : '';
  };
  const itemTemplate = (data: any): JSX.Element => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            backgroundColor: data.rostercolor,
            width: '20px',
            height: '20px',
            borderRadius: '5px',
          }}
        ></div>
        <span>{data.rosterCode}</span>
      </div>
    );
  };
  const valueTemplate = (data: any): JSX.Element => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '6px',
        }}
      >
        <div
          style={{
            backgroundColor: data.rostercolor,
            width: '20px',
            height: '20px',
            borderRadius: '5px',
          }}
        ></div>
        <span>{data.rosterCode}</span>
      </div>
    );
  };
  const rowTemplateDynamic = (
    tradeName: string,
    dataSet: Array<any>,
    row: number,
    numberTrades: number,
    assign_index: number
  ) => {
    const test123 = actionData.findIndex(
      (e) => e.day_sequence === '' + '1' + '1'
    );

    return (
      <tr
        style={{
          backgroundColor: context.isDarkMode ? '#15202B' : 'white',
          color: 'white',
        }}
      >
        <td
          style={{
            backgroundColor: context.isDarkMode ? '#15202B' : 'white',
            color: 'white',
          }}
        >
          {row}. {tradeName}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '1'}
            dataSource={roosterData}
            onChange={changeDrop.bind([], assign_index)}
            itemTemplate={itemTemplate}
            fields={fieldsForDropdown}
            valueTemplate={valueTemplate}
            value={
              dataSet[
                dataSet?.findIndex((e) => e.day_sequence === '' + row + '1')
              ]?.shift
            }
            width={'110px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '2'}
            dataSource={roosterData}
            onChange={changeDrop.bind([], assign_index)}
            itemTemplate={itemTemplate}
            fields={fieldsForDropdown}
            valueTemplate={valueTemplate}
            value={
              dataSet[
                dataSet?.findIndex((e) => e.day_sequence === '' + row + '2')
              ]?.shift
            }
            width={'110px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '3'}
            dataSource={roosterData}
            onChange={changeDrop.bind([], assign_index)}
            itemTemplate={itemTemplate}
            fields={fieldsForDropdown}
            valueTemplate={valueTemplate}
            value={
              dataSet[
                dataSet?.findIndex((e) => e.day_sequence === '' + row + '3')
              ]?.shift
            }
            width={'110px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '4'}
            dataSource={roosterData}
            onChange={changeDrop.bind([], assign_index)}
            itemTemplate={itemTemplate}
            fields={fieldsForDropdown}
            valueTemplate={valueTemplate}
            value={
              dataSet[
                dataSet?.findIndex((e) => e.day_sequence === '' + row + '4')
              ]?.shift
            }
            width={'110px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '5'}
            dataSource={roosterData}
            onChange={changeDrop.bind([], assign_index)}
            itemTemplate={itemTemplate}
            fields={fieldsForDropdown}
            valueTemplate={valueTemplate}
            value={
              dataSet[
                dataSet?.findIndex((e) => e.day_sequence === '' + row + '5')
              ]?.shift
            }
            width={'110px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '6'}
            dataSource={roosterData}
            onChange={changeDrop.bind([], assign_index)}
            itemTemplate={itemTemplate}
            fields={fieldsForDropdown}
            valueTemplate={valueTemplate}
            value={
              dataSet[
                dataSet?.findIndex((e) => e.day_sequence === '' + row + '6')
              ]?.shift
            }
            width={'110px'}
          />{' '}
        </td>
        <td>
          {' '}
          <DropDownListComponent
            id={'' + row + '7'}
            dataSource={roosterData}
            onChange={changeDrop.bind([], assign_index)}
            itemTemplate={itemTemplate}
            fields={fieldsForDropdown}
            valueTemplate={valueTemplate}
            value={
              dataSet[
                dataSet?.findIndex((e) => e.day_sequence === '' + row + '7')
              ]?.shift
            }
            width={'110px'}
          />{' '}
        </td>
      </tr>
    );
  };
  const renderWeeks = () => {
    list = [];
    for (var i = 1; i <= weeksValue; i++) {
      if (Array.isArray(assignments[0])) {
        assignments = assignments[0];
      }
      assignments.map((assignment: any, iUser: number) => {
        // let theR = assignment.first_name[0] + '.' + assignment.last_name[0];
        let Name = assignment.alias_name;
        if (assignment.trades?.length > 0) {
          assignment.trades?.map((tr: any, index: number) => {
            if (index % 2 === 0) {
              list.push(
                rowTemplateDynamic(
                  Name + '-' + tr.trade_code,
                  unionUserData[iUser],
                  i,
                  1,
                  iUser
                )
              );
            } else {
              list.push(
                rowTemplateDynamic(
                  Name + '-' + tr.trade_code,
                  unionUserData[iUser],
                  i,
                  1,
                  iUser
                )
              );
            }
          });
        } else {
          list.push(rowTemplateDynamic(Name, unionUserData[0], i, 1, iUser));
        }
      });
    }

    list.sort((a, b) => {
      const nameA = a.props.children[0].props.children[2]?.toUpperCase();
      const nameB = b.props.children[0].props.children[2]?.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    });
    return list;
  };
  const createCapacityforAssignment = async () => {
    loadingShow(true, 'Adding');
    if (rangeDefined) {
      const start = new Date(rangeDefined.startTime);
      const end = new Date(rangeDefined.endTime);
      if (end.getHours() === 0 && end.getMinutes() === 0 && end.getSeconds() === 0) {
        end.setDate(end.getDate() - 1);
      }
      dateRangePickerTemplateValue = [start, end];
      dateRangePickerExceptionValue = [start, end];
    }
    if (!isNoteMode) {
      if (isException) {
        if (dropDownExceptionSelection === -1 && !deleteExceptionSwichValue2) {
          Message.error('Exception field cannot be empty');
          loadingShow(false);
          return false;
        }
        if (dateRangePickerExceptionValue === '') {
          Message.error('Time  cannot be empty');
          loadingShow(false);
          return false;
        }
        var sHour = new Date(dateRangePickerExceptionValue[0]);
        var eHour = new Date(dateRangePickerExceptionValue[1]);
        if (!deleteExceptionSwichValue2) {
          const theObj = {
            CapacityCollection: [...getSendDataFServerSideEx(sHour, eHour)],
          };
          AddCapacityRequest(theObj, () => {
            context.setDataChange(true);
            setHideDialogCapacity(false);
          });
        } else {
          if (dropDownExceptionSelection != -1) {
            const theObj = {
              CapacityCollection: [...getSendDataFServerSideEx(sHour, eHour)],
              state_of_proc: 'exception',
              start_date: new Date(
                new Date(sHour).getTime()
              ),
              end_date: new Date(
                new Date(eHour).getTime()
              ),
              diff_to_TimeZone: `${Number(getTimeZoneDifference()) / (60000 * 60)
                }:00:00`,
            };
            AddCapacityRequest(theObj, () => {
              context.setDataChange(true);
              setHideDialogCapacity(false);
            });
          } else {
            var sendebleObject = [
              ...assignments.map((assignment) => {
                return {
                  assignment_id: Number(assignment.assignment_id),
                  start_date: toLocalISOString(new Date(sHour)),
                  end_date: toLocalISOString(new Date(eHour)),
                  type: 'exception',
                  diff_to_TimeZone: `${Number(getTimeZoneDifference()) / (60000 * 60)
                    }:00:00`,
                };
              }),
            ];
            DeleteCapacityRequest(sendebleObject, () => {
              setIsDangerShow(false);
              setHideDialogCapacity(false);
              context.setDataChange(true);
              context.setChangeTabPane(true);
            });
          }
        }
        if (deleteCapacitySwichValue2) {
          var sendebleObjectDelete: any = [
            ...assignments.map((assignment) => {
              return {
                assignment_id: Number(assignment.assignment_id),
                start_date: toLocalISOString(new Date(sHour)),
                end_date: toLocalISOString(new Date(eHour)),
                type: 'capacity',
                diff_to_TimeZone: `${Number(getTimeZoneDifference()) / (60000 * 60)
                  }:00:00`,
              };
            }),
          ];
          DeleteCapacityRequest(sendebleObjectDelete, () => {
            setIsDangerShow(false);
            setHideDialogCapacity(false);
            context.setDataChange(true);
            context.setChangeTabPane(true);
          });
        }
      } else {
        if (dropDownTemlateSelection === '' && !deleteCapacitySwichValue1) {
          Message.error('Template field cannot be empty');
          loadingShow(false);
          return false;
        }
        if (dateRangePickerTemplateValue === '') {
          Message.error('Time  cannot be empty');
          loadingShow(false);
          return false;
        }
        const dateRange = Object.create(dateRangePickerTemplateValue);
        const startTime = new Date(dateRange[0]);
        const endTime = new Date(dateRange[1]);
        if (!deleteCapacitySwichValue1) {
          var theObj = {
            CapacityCollection: [...getSendDataFServer(startTime, endTime)],
          };
          let add = await AddCapacityRequest(theObj, () => {
            setHideDialogCapacity(false);
          });
        } else {
          if (isRosterTemplateSelected) {
            const theObj = {
              CapacityCollection: [...getSendDataFServer(startTime, endTime)],
              state_of_proc: 'capacity',
              start_date: new Date(
                new Date(startTime).getTime()
              ),
              end_date: new Date(
                new Date(endTime).getTime()
              ),
              diff_to_TimeZone: `${Number(getTimeZoneDifference()) / (60000 * 60)
                }:00:00`,
            };

            if (deleteExceptionSwichValue1) {
              var sendebleObject2 = [
                ...assignments.map((assignment) => {
                  return {
                    assignment_id: Number(assignment.assignment_id),
                    start_date: toLocalISOString(new Date(startTime)),
                    end_date: toLocalISOString(new Date(endTime)),
                    type: 'capacity',
                    diff_to_TimeZone: `${Number(getTimeZoneDifference()) / (60000 * 60)
                      }:00:00`,
                  };
                }),
              ];
              await DeleteCapacityRequest(sendebleObject2, () => {
                setIsDangerShow(false);
                setHideDialogCapacity(false);
              });
            }
            let add = await AddCapacityRequest(theObj, () => {
              setHideDialogCapacity(false);
            });
          } else {
            const sendebleObject: Array<any> = [
              ...assignments.map((assignment) => {
                return {
                  assignment_id: Number(assignment.assignment_id),
                  start_date: toLocalISOString(new Date(startTime)),
                  end_date: toLocalISOString(new Date(endTime)),
                  type: 'capacity',
                  diff_to_TimeZone: `${Number(getTimeZoneDifference()) / (60000 * 60)
                    }:00:00`,
                };
              }),
            ];
            await DeleteCapacityRequest(sendebleObject, () => {
              setIsDangerShow(false);
              setHideDialogCapacity(false);
            });
          }
        }
        loadingShow(false);
        context.setDataChange(true);
        context.setChangeTabPane(true);
      }
    } else {
      if (
        dateRangePickerExceptionValue === '' ||
        noteDesc.value === null ||
        theTypeDD.value === null
      ) {
        Message.error('Time,type or note field cannot be empty');
        loadingShow(false);
        return false;
      }
      var sHour = new Date(dateRangePickerExceptionValue[0]);
      var eHour = new Date(dateRangePickerExceptionValue[1]);
      let theData: Array<any> = [];
      let theNote = noteDesc.value;
      assignments.map((assignment) => {
        getNoteObject(theData, assignment, sHour, eHour, theNote);
      });
      const dataCollection = {
        CapacityCollection: [...theData],
      };
      let collectionLength = dataCollection?.CapacityCollection?.length - 1;
      let firstData = dataCollection?.CapacityCollection[0];
      let lastData = dataCollection?.CapacityCollection[collectionLength];
      const theObj = {
        app: 'UWORK',
        organization_id: all_information.company_id.toString(),
        assignmentid: firstData.assignmentid,
        starttime: firstData.starttime,
        endtime: lastData.endtime,
        created_by: all_information.user_id,
        creation_date: new Date(),
        shift: 'NOTE',
        comments: firstData.comments,
        explanation: firstData.explanation,
        shift_color: firstData.shift_color,
      };

      let objCollection: any = {};
      if (isCapacitySwitchChecked) {
        objCollection = {
          CapacityCollection: [theObj],
          state_of_proc: 'capacity',
          diff_to_TimeZone: `${Number(getTimeZoneDifference()) / (60000 * 60)
            }:00:00`,
          end_date: lastData.endtime,
          start_date: firstData.starttime,
        };
      } else {
        objCollection = {
          CapacityCollection: [theObj],
        };
      }

      CreateNoteCapacity(objCollection, () => {
        context.setDataChange(true);
        setHideDialogCapacity(false);
      });
    }
  };
  const toLocalISOString = (date: Date): string => {
    const pad = (n: number) => String(n).padStart(2, '0');
    return (
      date.getFullYear() +
      '-' + pad(date.getMonth() + 1) +
      '-' + pad(date.getDate()) +
      'T' + pad(date.getHours()) +
      ':' + pad(date.getMinutes()) +
      ':' + pad(date.getSeconds())
    );
  };
  const getTimeZoneDifference = () => {

    const browserOffsetMinutes = moment(new Date()).utcOffset();
    const serverOffsetMinutes = (server_gmt ?? 11) * 60;
    const result = browserOffsetMinutes - serverOffsetMinutes;
    return result * 60000;
  };
  const getSendDataFServer = (sTime: any, eTime: any) => {
    const days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    const theStartTime = new Date(sTime);
    const theEndTime = new Date(eTime);
    var currentDate = theStartTime;
    const dates: Array<any> = [];
    while (currentDate <= theEndTime) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    const startIndexToCopy = weekStartNumber;
    let theTempToDays = Object.create(days);
    const parseTemp = theTempToDays.splice(startIndexToCopy);
    parseTemp.push(...theTempToDays);
    let theDay = dates[0].getDay();
    var indexOfBreak = parseTemp.findIndex((e: any) => {
      return e === days[theDay];
    });

    const allSendData: Array<any> = [];
    assignments.map((assi, assi_index: number) => {
      if (Array.isArray(assi)) {
        assi = assi[0];
      }
      if (assi.trades.length > 0) {
        assi.trades?.map((tr: any, index: number) => {
          let theTempOfTheData = Object.create(unionUserData[assi_index]);
          let startIndex = 7 * index * weeksValue;
          let endIndex = 7 * (index + 1) * weeksValue - 1;
          let theResult = theTempOfTheData.splice(startIndex, endIndex + 1);
          getCapacityForAssignemnts(
            dates,
            theResult,
            indexOfBreak,
            allSendData,
            tr,
            assi
          );
        });
      } else {
        getCapacityForAssignemnts(
          dates,
          unionUserData[assi_index] ?? [],
          indexOfBreak,
          allSendData,
          undefined,
          assi
        );
      }
    });

    return allSendData;
  };
  const getCapacityForAssignemnts = (
    dates: Date[],
    theTotalData: Array<any>,
    indexOfBreak: number,
    allSendData: Array<any>,
    trade: any,
    assignment: any
  ) => {
    let theTempToData = Object.create(theTotalData);
    var totalData = theTempToData.splice(indexOfBreak);
    totalData.push(...theTempToData);
    let indexOfShiftPeriod = 0;
    for (let i = 0; i < dates.length; i++) {
      var theDate = dates[i];
      var theShiftData = [];
      theShiftData.push(totalData[indexOfShiftPeriod]);
      if(theShiftData[0] !== undefined){
        if (theShiftData[0].shift !== null && theShiftData[0].shift) {

          if (totalData[indexOfShiftPeriod].element_alias === 'NS') {
  
            var startHour = theShiftData[0].start_time?.split(':');
            var workHour = theShiftData[0].end_time?.split(':');
            var thestartTime: any = moment(theDate)
              .add(startHour[0], 'h')
              .add(Number(startHour[1]), 'm')
              .add(startHour[2], 's')
              .toDate();
            let theendTime: Date = new Date(thestartTime)
              theendTime.setDate(theendTime.getDate() + 1);
              theendTime.setHours(0,0,0);
            // if (theCheckDayInCurrentDate === theCheckDayInEndDate) {
            let upToDateStart = new Date(thestartTime);
            let upToDateEnd = new Date(theendTime);
            let breakTimePerCapacity = (totalData[indexOfShiftPeriod].break_time.split(":")[0]) / 2;
            let capacityhoursBeforeMid=(24 -(totalData[indexOfShiftPeriod].start_time?.split(":")[0])-breakTimePerCapacity) *60;
            let capacityhoursAfterMid=(totalData[indexOfShiftPeriod].end_time?.split(":")[0]  -breakTimePerCapacity)*60;
  
            allSendData.push({
              day_seq: totalData[indexOfShiftPeriod].day_sequence,
              shift: totalData[indexOfShiftPeriod].shift,
              assignmentid: assignment.assignment_id,
              break_time: totalData[indexOfShiftPeriod].break_time,
              capacityhours:capacityhoursBeforeMid?.toString(),
              element_alias: totalData[indexOfShiftPeriod].element_alias,
              endtime: toLocalISOString(upToDateEnd),
              end_time: totalData[indexOfShiftPeriod].end_time,
              shift_color: totalData[indexOfShiftPeriod].shift_color,
              starttime: toLocalISOString(upToDateStart),
              start_time: totalData[indexOfShiftPeriod].start_time,
              team_id: assignment.teams[0]?.team_id,
              team_code: assignment.teams[0]?.team_code,
              template_id: Number(totalData[indexOfShiftPeriod].templateId),
              trade_id: trade?.trade_id,
              trade_code: trade?.trade_code,
              app: 'UWORK',
              organization_id: all_information.company_id?.toString(),
              created_by: all_information.user_id,
              creation_date: new Date(),
            });
  
  
            var startHour = theShiftData[0].start_time?.split(':');
            var workHour = totalData[indexOfShiftPeriod].end_time?.split(':');
            thestartTime = new Date(thestartTime)
            thestartTime.setDate(thestartTime.getDate() + 1);
            thestartTime.setHours(0,0,0);
  
            
             theendTime = moment(thestartTime)
              .add(Number(workHour[0]), 'h')
              .add(Number(workHour[1]), 'm')
              .add(Number(workHour[2]), 's')
              .toDate();
            // if (theCheckDayInCurrentDate === theCheckDayInEndDate) {
             upToDateStart = new Date(thestartTime);
             upToDateEnd = new Date(theendTime);
  
            allSendData.push({
              day_seq: totalData[indexOfShiftPeriod].day_sequence,
              shift: totalData[indexOfShiftPeriod].shift,
              assignmentid: assignment.assignment_id,
              break_time: totalData[indexOfShiftPeriod].break_time,
              capacityhours:capacityhoursAfterMid?.toString(),
              element_alias: totalData[indexOfShiftPeriod].element_alias,
              endtime: toLocalISOString(upToDateEnd),
              end_time: totalData[indexOfShiftPeriod].end_time,
              shift_color: totalData[indexOfShiftPeriod].shift_color,
              starttime: toLocalISOString(upToDateStart),
              start_time: totalData[indexOfShiftPeriod].start_time,
              team_id: assignment.teams[0]?.team_id,
              team_code: assignment.teams[0]?.team_code,
              template_id: Number(totalData[indexOfShiftPeriod].templateId),
              trade_id: trade?.trade_id,
              trade_code: trade?.trade_code,
              app: 'UWORK',
              organization_id: all_information.company_id?.toString(),
              created_by: all_information.user_id,
              creation_date: new Date(),
            });
  
          }
          else if(totalData[indexOfShiftPeriod].element_alias === 'DS') {

            var startHour = theShiftData[0].start_time?.split(':');
            var workHour = theShiftData[0].end_time?.split(':');

            console.log("workHour: ",workHour)
            var thestartTime: any = moment(theDate)
                .add(startHour[0], 'h')
                .add(Number(startHour[1]), 'm')
                .add(startHour[2], 's')
                .toDate();
            var theendTime: any = moment(theDate)
                .add(Number(workHour[0]), 'h')
                .add(Number(workHour[1]), 'm')
                .add(Number(workHour[2]), 's')
                .toDate();
            console.log("thestartTime: ",thestartTime)
            console.log("theendTime: ",theendTime)
            // if (theCheckDayInCurrentDate === theCheckDayInEndDate) {
            let upToDateStart = new Date(thestartTime);
            let upToDateEnd = new Date(theendTime);
            allSendData.push({
              day_seq: totalData[indexOfShiftPeriod].day_sequence,
              shift: totalData[indexOfShiftPeriod].shift,
              assignmentid: assignment.assignment_id,
              break_time: totalData[indexOfShiftPeriod].break_time,
              capacityhours: totalData[indexOfShiftPeriod].capacity?.toString(),
              element_alias: totalData[indexOfShiftPeriod].element_alias,
              endtime: toLocalISOString(upToDateEnd),
              end_time: totalData[indexOfShiftPeriod].end_time,
              shift_color: totalData[indexOfShiftPeriod].shift_color,
              starttime: toLocalISOString(upToDateStart),
              start_time: totalData[indexOfShiftPeriod].start_time,
              team_id: assignment.teams[0]?.team_id,
              team_code: assignment.teams[0]?.team_code,
              template_id: Number(totalData[indexOfShiftPeriod].templateId),
              trade_id: trade?.trade_id,
              trade_code: trade?.trade_code,
              app: 'UWORK',
              organization_id: all_information.company_id?.toString(),
              created_by: all_information.user_id,
              creation_date: new Date(),
            });
          }
          else{

            console.log("theShiftData[0]: ",theShiftData[0])
            var startHour = theShiftData[0].start_time?.split(':');
            var endHour = theShiftData[0].end_time?.split(':');

            var thestartTime : any = moment(theDate)
                .set('hour', Number(startHour[0]))
                .set('minute', Number(startHour[1]))
                .set('second', Number(startHour[2]));

            var theendTime : any = moment(theDate)
                .set('hour', Number(endHour[0]))
                .set('minute', Number(endHour[1]))
                .set('second', Number(endHour[2]));

            let upToDateStart = new Date(thestartTime);
            let upToDateEnd = new Date(theendTime);
            allSendData.push({
              day_seq: totalData[indexOfShiftPeriod].day_sequence,
              shift: totalData[indexOfShiftPeriod].shift,
              assignmentid: assignment.assignment_id,
              break_time: totalData[indexOfShiftPeriod].break_time,
              capacityhours: totalData[indexOfShiftPeriod].capacity?.toString(),
              element_alias: totalData[indexOfShiftPeriod].element_alias,
              endtime: toLocalISOString(upToDateEnd),
              end_time: totalData[indexOfShiftPeriod].end_time,
              shift_color: totalData[indexOfShiftPeriod].shift_color,
              starttime: toLocalISOString(upToDateStart),
              start_time: totalData[indexOfShiftPeriod].start_time,
              team_id: assignment.teams[0]?.team_id,
              team_code: assignment.teams[0]?.team_code,
              template_id: Number(totalData[indexOfShiftPeriod].templateId),
              trade_id: trade?.trade_id,
              trade_code: trade?.trade_code,
              app: 'UWORK',
              organization_id: all_information.company_id?.toString(),
              created_by: all_information.user_id,
              creation_date: new Date(),
            });
















          }
        }
      }
      if (indexOfShiftPeriod === totalData.length - 1) {
        indexOfShiftPeriod = -1;
      }
      indexOfShiftPeriod += 1;
    }
    actionData = [];
    return allSendData;
  };
  const getSendDataFServerSideEx = (sTime: any, eTime: any) => {
    const theStartTime = new Date(sTime);
    const theEndTime = new Date(eTime);
    let sException = exceptionData.filter((e: any) => {
      return e.rosterId === Number(dropDownExceptionSelection);
    });

    let allSendDataToException: Array<any> = [];
    assignments.map((assignment) => {
      if (assignment?.trades?.length > 0) {
        assignment?.trades?.map((tr: any) => {
          getExceptionForAssignment(
            allSendDataToException,
            sException[0],
            assignment,
            tr,
            theStartTime,
            theEndTime
          );
        });
      } else {
        assignment?.trades?.map((tr: any) => {
          getExceptionForAssignment(
            allSendDataToException,
            sException[0],
            assignment,
            undefined,
            theStartTime,
            theEndTime
          );
        });
      }
    });
    return allSendDataToException;
  };
  const getExceptionForAssignment = (
    data: Array<any>,
    cEx: any,
    assignment: any,
    tr: any,
    sTime: Date,
    eTime: Date
  ) => {
    cEx.assignment = assignment.assignment_id;
    cEx.day_seq = '';
    if (isSameDay) {
      var duration = $('#duration').val() as any;
      var theSplitDuration = duration?.split(':');
      const capacity =
        Number(theSplitDuration[0]) * 60 + Number(theSplitDuration[1]);
      const startTime = moment(sTime.getTime())
        .add((exeptionStarthour as Date).getHours(), 'h')
        .add((exeptionStarthour as Date).getMinutes(), 'm')
        .toDate();

      const endTime = moment(startTime)
        .add((exeptionDuration as Date).getHours(), 'h')
        .add((exeptionDuration as Date).getMinutes(), 'm')
        .toDate();
      data.push({
        day_seq: cEx.day_seq,
        shift: cEx.rosterCode,
        assignmentid: cEx.assignment,
        break_time: cEx.breakTime,
        capacityhours: (-capacity).toString(),
        element_alias: cEx.elementAliasValue,
        endtime: toLocalISOString(new Date(endTime)),
        shift_color: cEx.rostercolor,
        starttime: toLocalISOString(new Date(startTime)),
        team_id: assignment.teams[0].team_id,
        team_code: assignment.teams[0].team_code,
        trade_id: tr?.trade_id,
        trade_code: tr?.trade_code,
        template_id: Number(dropDownExceptionSelection),
        app: 'UWORK',
        organization_id: all_information.company_id?.toString(),
        created_by: all_information.user_id,
        creation_date: new Date(),
      });
    } else {
      startTime = dateRangePickerExceptionValue[0];
      endTime = dateRangePickerExceptionValue[1];
      const dates: Array<any> = [];
      var currentDateException = new Date(sTime);
      while (currentDateException <= new Date(eTime)) {
        dates.push(new Date(currentDateException));
        currentDateException.setDate(currentDateException.getDate() + 1);
      }
      cEx.capacity = -24 * 60;
      for (let i = 0; i < dates.length; i++) {
        var theDate = dates[i];
        var theShiftData = [];
        var theTampon = [];
        theTampon.push(cEx);
        theShiftData.push(...theTampon);
        var startTime: any = moment(theDate)
          .add(0, 'h')
          .add(0, 'm')
          .add(0, 's')
          .toDate();
        var endTime: any = moment(startTime)
          .add(23, 'h')
          .add(59, 'm')
          .add(59, 's')
          .toDate();
        let upToDateStart = new Date(startTime);
        let upToDateEnd = new Date(endTime);
        theShiftData[0].start_date = upToDateStart;
        theShiftData[0].end_date = upToDateEnd;
        data.push({
          day_seq: theShiftData[0].day_seq,
          shift: theShiftData[0].rosterCode,
          assignmentid: theShiftData[0].assignment,
          break_time: theShiftData[0].breakTime,
          capacityhours: theShiftData[0].capacity?.toString(),
          element_alias: theShiftData[0].elementAliasValue,
          endtime: toLocalISOString(upToDateEnd),
          shift_color: theShiftData[0].rostercolor,
          starttime: toLocalISOString(upToDateStart),
          team_id: assignment.teams[0].team_id,
          team_code: assignment.teams[0].team_code,
          template_id: Number(dropDownExceptionSelection),
          trade_id: tr?.trade_id,
          trade_code: tr?.trade_code,
          app: 'UWORK',
          organization_id: all_information.company_id?.toString(),
          created_by: all_information.user_id,
          creation_date: new Date(),
        });
      }
    }
  };
  const getNoteObject = (
    data: Array<any>,
    assignment: any,
    sTime: Date,
    eTime: Date,
    note: string
  ) => {
    startTime = dateRangePickerExceptionValue[0];
    endTime = dateRangePickerExceptionValue[1];
    const dates: Array<any> = [];
    var currentDateException = new Date(sTime);
    while (currentDateException <= new Date(eTime)) {
      dates.push(new Date(currentDateException));
      currentDateException.setDate(currentDateException.getDate() + 1);
    }
    for (let i = 0; i < dates.length; i++) {
      var theDate = dates[i];
      var startTime: any = moment(theDate)
        .add(0, 'h')
        .add(0, 'm')
        .add(0, 's')
        .toDate();
      var endTime: any = moment(startTime)
        .add(23, 'h')
        .add(59, 'm')
        .add(59, 's')
        .toDate();
      let upToDateStart = new Date(startTime);
      let upToDateEnd = new Date(endTime);
      data.push({
        day_seq: '',
        shift: 'NOTE',
        comments: note,
        explanation: theTypeDD.value,
        assignmentid: assignment.assignment_id,
        break_time: '0',
        capacityhours: '0',
        element_alias: '',
        endtime: toLocalISOString(upToDateEnd),
        shift_color: selectedNoteColor && selectedNoteColor,
        starttime: toLocalISOString(upToDateStart),
        team_id: 0,
        team_code: '',
        template_id: 0,
        trade_id: 0,
        trade_code: '',
        app: 'UWORK',
        organization_id: all_information.company_id?.toString(),
        created_by: all_information.user_id,
        creation_date: new Date(),
      });
    }
  };
  useEffect(() => {
    selectedName = assignments.map((el) => el.alias_name).toString();

    deleteCapacitySwichValue1 = true;
    deleteExceptionSwichValue1 = true;
    deleteCapacitySwichValue2 = true;
    deleteExceptionSwichValue2 = true;
    selectedChip = [0, 1];
    selectedChip2 = [0, 1];
    weekStartNumber = -1;
    dropDownExceptionSelection = -1;
    exeptionStarthour = new Date();
    exeptionDuration = new Date();

    if (rangeDefined) {
      const start = new Date(rangeDefined.startTime);
      const end = new Date(rangeDefined.endTime);
      if (end.getHours() === 0 && end.getMinutes() === 0 && end.getSeconds() === 0) {
        end.setDate(end.getDate() - 1);
      }
      dateRangePickerTemplateValue = [start, end];
      dateRangePickerExceptionValue = [start, end];
      const isSame = start.toDateString() === end.toDateString();
      setIsSameDay(isSame);
    } else {
      dateRangePickerTemplateValue = '';
      dateRangePickerExceptionValue = '';
      setIsSameDay(false);
    }

    const get = async () => {
      await getShiftData();
    };
    get();
  }, []);
  useEffect(() => {
    if (!isNoteMode) {
      if (isException) {
        theDialog.content = exceptionForm;
      } else {
        theDialog.content = shiftContent;
      }
    } else {
      theDialog.content = noteContent;
    }
    theDialog.refresh();
    return () => { };
  }, [
    TemplateData,
    exceptionData,
    isRosterTemplateSelected,
    weekDay,
    isSameDay,
  ]);
  const exceptionForm = () => {
    return (
      <div>
        <div className='row'>
          <div className='col-md-3'>Name:</div>
          <div className='col-md-5'>
            <div className='form-group'>
              <label className='control-label'>{selectedName}</label>
            </div>
          </div>
          <div className='col-md-2'>
            <span>Exception:</span>
          </div>
          <div className='col-md-2'>
            <SwitchComponent
              id='switch-is-expection-yes-no'
              change={swichTemplateToExpection}
              onLabel={'yes'}
              offLabel={'no'}
              enableRtl={true}
              checked={true}
            />
          </div>
        </div>
        <div
          className='row md-6'
          style={{ alignSelf: 'end', display: 'flex', marginLeft: 185 }}
        >
          <ChipListComponent
            id='chip-filter'
            selectedChips={selectedChip2}
            selection='Multiple'
            click={isChipClicked2}
          >
            <ChipsDirective>
              <ChipDirective
                text='Clear [Exception]'
                cssClass='e-chip-text1'
                value={12}
              ></ChipDirective>
              <ChipDirective
                text='Clear [Capacity]'
                cssClass='e-chip-text2'
              ></ChipDirective>
            </ChipsDirective>
          </ChipListComponent>
        </div>
        <div className='row mb-3'>
          <div className='col-md-3'>Exception:</div>
          <div className='col-md-9'>
            <div className='form-group'>
              <DropDownListComponent
                dataSource={exceptionData}
                placeholder='Select an exeption'
                fields={{ text: 'rosterCode', value: 'rosterId' }}
                value={dropDownExceptionSelection}
                onChange={(e: any) => {
                  dropDownExceptionSelection = e.value;

                  dateRangePicker({
                    value: dateRangePickerExceptionValue,
                  });
                }}
                itemTemplate={itemTemplateShiftColor}
              />
            </div>
          </div>
        </div>
        <div className='row mb-3'>
          <div className='col-md-3'>Range:</div>
          <div className='col-md-9'>
            <DateRangePickerComponent
              onChange={dateRangePicker}
              delayUpdate={true}
              cssClass='customCSS '
              format={'dd/MM/yyyy'}
              id='daterangepicker'
              placeholder='Select a range'
              value={dateRangePickerExceptionValue}
            />
          </div>
        </div>
        {isSameDay ? (
          <>
            <div className='row mb-3'>
              <div className='col-md-3'>Start Hour:</div>
              <div className='col-md-9'>
                <TimePickerComponent
                  id='datetimepickerStart'
                  strictMode={false}
                  placeholder='Start Hour'
                  format={'HH:mm:ss'}
                  value={exeptionStarthour}
                  onChange={(e: any) => {
                    exeptionStarthour = e.value;
                  }}
                />
              </div>
            </div>

            <div className='row mb-3'>
              <div className='col-md-3'>Duration</div>
              <div className='col-md-9'>
                <TimePickerComponent
                  id='duration'
                  strictMode={false}
                  placeholder='Duration'
                  onChange={onChangeDuration}
                  format={'HH:mm:ss'}
                  step={15}
                  value={exeptionDuration}
                />
              </div>
            </div>
            <div className='row mb-3'>
              {showEndDate === true ? (
                <>
                  <div className='col-md-3'>End Hour</div>
                  <div className='col-md-9'>
                    <TimePickerComponent
                      id='datetimepickerEnd'
                      strictMode={false}
                      placeholder='End Hour'
                      format={'HH:mm:ss'}
                      value={endDate}
                      disabled={true}
                      step={15}
                    />
                  </div>
                </>
              ) : null}
            </div>
          </>
        ) : null}
        <div
          className='alert alert-danger'
          style={{
            display: isDangerShow2 ? '' : 'none',
            fontSize: 11,
          }}
        >
          <p>
            Warning - all capacity shift information will be purged for the
            selected tradesperson for the period selected
          </p>
        </div>
      </div>
    );
  };
  const noteContent = () => {
    return (
      <div>
        <TPlannerNoteContent
          dateRangePickerOnChange={dateRangePicker}
          dateRangePickeValue={dateRangePickerExceptionValue}
          texboxRef={(tb: any) => (noteDesc = tb)}
          selectedName={selectedName}
          dropDownRef={(dd: DropDownListComponent) => (theTypeDD = dd)}
          isVisible={true}
          onChange={(args: any) => {
            setSelectedNoteColor(args?.target?.itemData?.color);
          }}
          onCapacitySwitchChange={(args: any) => {
            setIsCapacitySwitchChecked(args?.checked);
          }}
        />
      </div>
    );
  };
  const shiftContent = () => {
    return (
      <div>
        <div className='row' style={{ width: '500px' }}>
          <div className='col-md-3'>Name:</div>

          <div className='col-md-5'>
            <div className='form-group'>
              <label className='control-label'>{selectedName}</label>
            </div>
          </div>
          <div className='col-md-2'>
            <span>Exception:</span>
          </div>
          <div className='col-md-2'>
            <SwitchComponent
              id='switch-is-exeption'
              change={swichTemplateToExpection}
              onLabel={isException ? '' : 'no'}
              offLabel={isException ? 'no' : 'no'}
              enableRtl={true}
              checked={false}
            />
          </div>
        </div>
        <div
          className='row md-1'
          style={{
            alignSelf: 'end',
            display: 'flex',
            marginLeft: 185,
          }}
        >
          <ChipListComponent
            id='chip-filter'
            selectedChips={selectedChip}
            selection='Multiple'
            click={isChipClicked1}
          >
            <ChipsDirective>
              <ChipDirective
                text='Clear [Exception]'
                cssClass='e-chip-text1'
                value={12}
              ></ChipDirective>
              <ChipDirective
                text='Clear [Capacity]'
                cssClass='e-chip-text2'
              ></ChipDirective>
            </ChipsDirective>
          </ChipListComponent>
        </div>
        <div className='row mb-3' style={{ width: '490px' }}>
          <div className='col-md-3'>Template:</div>
          <div className='col-md-9'>
            <div className='form-group'>
              <DropDownListComponent
                fields={{ value: 'id', text: 'description' }}
                onChange={selectTemplateOnChange}
                dataSource={TemplateData}
                placeholder='Select a template'
                value={dropDownTemlateSelection}
                style={{ overflow: 'scroll' }}
              />
            </div>
          </div>
        </div>
        <div className='row mb-3' style={{ width: '490px' }}>
          <div className='col-md-3'>Range:</div>
          {rangeDefined ? (
            (() => {
              const displayEnd = new Date(rangeDefined.endTime);
              if (displayEnd.getHours() === 0 && displayEnd.getMinutes() === 0 && displayEnd.getSeconds() === 0) {
                displayEnd.setDate(displayEnd.getDate() - 1);
              }
              return `${rangeDefined.startTime.getDate()}.${rangeDefined.startTime.getMonth() + 1
              }.${rangeDefined.startTime.getFullYear()} - ${displayEnd.getDate()}.${displayEnd.getMonth() + 1
              }.${displayEnd.getFullYear()}`;
            })()
          ) : (
            <div className='col-md-9'>
              <DateRangePickerComponent
                onChange={dateRangePickerTemplate}
                cssClass='customCSS '
                id='daterangepicker'
                placeholder='Select a range'
                format={'dd/MM/yyyy'}
                value={dateRangePickerTemplateValue}
              />
            </div>
          )}
        </div>
        <div
          className='alert alert-danger'
          style={{
            display: isDangerShow ? '' : 'none',
            fontSize: 11,
          }}
        >
          <p>
            Warning - all capacity shift information will be purged for the
            selected tradesperson for the period selected
          </p>
        </div>
        <div className='content-rows'>
          {isRosterTemplateSelected ? (
            <table
              className='table   table-hover'
              style={{
                border: '1px solid gray',

                backgroundColor: context.isDarkMode ? '#15202B' : 'white',
                color: context.isDarkMode ? 'white' : '#15202B',
              }}
            >
              <tbody>
              <tr>
                <td>#</td>
                {weekDay.map((e2: any, i2: number) => (
                    <td key={i2}>{e2}</td>
                ))}
              </tr>

              {renderWeeks().map((row: any, i: number) => (
                  <React.Fragment key={i}>{row}</React.Fragment>
              ))}

              <tr>
                <td colSpan={weekDay.length + 1} style={{ padding: '10px' }}></td>
              </tr>
              </tbody>
            </table>
          ) : null}
        </div>
      </div>
    );
  };
  return (
    <div>
      <DialogComponent
        style={{ marginBottom: '10px' }}
        ref={(dialog: DialogComponent) => (theDialog = dialog)}
        isModal={true}
        id='defaultdialog'
        showCloseIcon={true}
        visible={hideDialog}
        width={isRosterTemplateSelected ? '1100px' : '500px'}
        header={isNoteMode ? 'Assign Note' : 'Assign Shift Element'}
        buttons={buttons}
        open={() => setHideDialogCapacity(true)}
        close={() => setHideDialogCapacity(false)}
        content={isNoteMode ? noteContent : shiftContent}
      ></DialogComponent>
    </div>
  );
}

export default GenerateCapacity;
